var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEquality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    viewBox: "0 0 18 24",
    height: 24,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.5,16 A 0.5,0.5 0 0 1 8,16.5 V 20 h 1.5 a 0.5,0.5 0 0 1 0.5,0.5 v 1 A 0.5,0.5 0 0 1 9.5,22 H 8 v 1.5 A 0.5,0.5 0 0 1 7.5,24 h -1 A 0.5,0.5 0 0 1 6,23.5 V 22 H 4.5 A 0.5,0.5 0 0 1 4,21.5 v -1 A 0.5,0.5 0 0 1 4.5,20 H 6 V 16.5 A 0.5,0.5 0 0 1 6.5,16 Z M 17.328,0 a 0.5,0.5 0 0 1 0.5,0.5 v 4 a 0.5,0.5 0 0 1 -0.5,0.5 h -1 a 0.5,0.5 0 0 1 -0.5,-0.5 V 3.413 L 12.414,6.828 11,5.414 14.413,2 h -1.085 a 0.5,0.5 0 0 1 -0.5,-0.5 v -1 a 0.5,0.5 0 0 1 0.5,-0.5 z",
    id: "path2",
    style: {
      opacity: 0.5,
      fill: "currentColor",
      fillRule: "evenodd",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 10,
    r: 6,
    id: "circle4",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeOpacity: 1
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEquality);
export default __webpack_public_path__ + "static/media/icon-equality.5f2ad38bd463befdab6488383d0616bc.svg";
export { ForwardRef as ReactComponent };